import { Link } from "@tanstack/react-router"
import {
  NavigationMenu,
  NavigationMenuList,
  NavigationMenuItem,
} from "../navigation-menu/NavigationMenu"

export type ManagementMenuRoutes<
  TRoutePath extends string,
  Entities extends string,
> = {
  label: string
  path: TRoutePath
  entity: Entities
}

interface ManagementMenuProps<
  TRoutePath extends string,
  Entities extends string,
> {
  managementItems: ManagementMenuRoutes<TRoutePath, Entities>[]
}

export function ManagementMenu<
  TRoutePath extends string,
  Entities extends string,
>({ managementItems, ...props }: ManagementMenuProps<TRoutePath, Entities>) {
  return (
    <NavigationMenu
      className="bg-primary-light-blue w-full flex justify-between pt-4 overflow-y-scroll no-scrollbar"
      {...props}
    >
      <div className="screen-container">
        <NavigationMenuList className="justify-start h-11">
          {managementItems.map((item) => (
            <NavigationMenuItem key={item.path}>
              <Link
                to={item.path as unknown as string}
                className="[&.active]:bg-white hover:bg-soft-white transition-all duration-300 flex flex-row gap-2 p-3 rounded-t-sm"
              >
                {item.label}
              </Link>
            </NavigationMenuItem>
          ))}
        </NavigationMenuList>
      </div>
    </NavigationMenu>
  )
}
